<template>
  <v-layout>
    <v-dialog v-model="addSimsDialog">
      <v-card>
        <v-container class="text-xs-center">
          <v-switch
            v-model="bulk"
            label="Bulk Paste"
            color="primary"
          ></v-switch>
          <v-textarea label="Bulk Paste ICCID's Here" @keydown.prevent @input="updateICCID" v-model="inputICCID" v-if="bulk"/>
          <v-combobox
            clearable
            v-if="!bulk"
            v-model="ICCIDarray"
            chips
            deletable-chips
            label="Input ICCID and press enter"
            type="number"
            multiple
            outline
          ></v-combobox>
          <v-select v-model="provider" label="SIM Provider" :items="['Vodafone', 'O2 BT', 'Wireless Logic', 'Other', 'Customer Own']" />
          <v-select v-model="api" label="API" :items="['NIBC-API', 'Aquarius-API', 'O2-API', 'WL-API', 'N/A']" />
          <v-btn @click="addSIMS" color="primary" :disabled="ICCIDarray.length < 1" :loading="adding">Add SIMS</v-btn>
        </v-container>
      </v-card>
    </v-dialog>
    <v-tabs
      v-model="active"
      fixed-tabs
      slider-color="primary"
      style="width:100%;"
      v-if="!messageSent"
    >
      <v-tab
        v-for="n in ['SIMS', 'SMS', 'Details']"
        :key="n"
        ripple
      >
        {{ n }}

      </v-tab>
      <v-tab-item
        key="SIMS"
      >
        <v-card flat>
          <v-card-title>
            <v-btn color="primary" @click="addSimsDialog = true">
              Add SIMS
            </v-btn>
            <v-switch
              v-model="showDevices"
              label="Show Devices (slow)"
            ></v-switch>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="simSearch"
              append-icon="search"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table :loading="simsLoading" :search="simSearch" :items="formattedSIMS" :headers="simColumns">
            <template slot="items" slot-scope="props">
              <tr>
                <td>{{props.item.ICCID}}</td>
                <td>{{props.item.provider}}</td>
                <td>{{props.item.api}}</td>
                <td v-if="showDevices" :class="props.item.device === '' ? 'error' : ''">{{props.item.device}}</td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-tab-item>
      <v-tab-item
        key="SMS"
      >
        <v-card flat>
          <v-container v-if="!messageSent" class="text-xs-center">
      <v-select
        label="Message Type" 
        :items="types"
        v-model="messageType"
        item-value="type"
        item-text="name"
      />
      <v-switch
        v-model="bulk"
        label="Bulk Paste"
        color="primary"
      ></v-switch>
      <v-textarea label="Bulk Paste ICCID's Here" @keydown.prevent @input="updateICCID" v-model="inputICCID" v-if="bulk"/>
      <v-combobox
        v-if="!bulk"
        v-model="ICCIDarray"
        chips
        deletable-chips
        label="Input ICCID and press enter"
        type="number"
        multiple
        outline
        clearable
      ></v-combobox>
      <v-autocomplete
        label="Message Template"
        :items="messageTemplates"
        v-model="message"
        multiple
        chips
        deletable-chips
      />
      <v-text-field 
        v-for="(m, i) in message"
        v-model="message[i]"
        :key="i"
        :label="'Message To Send ' + (i+1)"
        :append-icon="$vuetify.icons.clear"
        @click:append="message.splice(i, 1)"
      />
      <v-btn @click="sendMessages" color="primary" :disabled="!message || ICCIDarray.length < 1" :loading="sending">Send Messages</v-btn>
    </v-container>  
        </v-card>
      </v-tab-item>
      <v-tab-item
        key="Details"
      >
        <v-card flat>
          <v-container v-if="!messageSent">
            <v-textarea v-model="excelInput" label="Excel Data Input"></v-textarea>
            <v-layout row wrap>
              <v-flex
                v-for="(column, i) in availableColumns"
                xs3
                :key="i"
              >
                <v-select
                  :label="'Column: ' + i"
                  v-model="columnMap[i]"
                  :items="availableColumns"
                  return-object
                  outline
                  class="mx-1"
                  height="1"
                />
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-checkbox v-model="includeHeaders" label="Input includes header row"></v-checkbox>
              <v-spacer></v-spacer>
              <v-btn color="primary" @click="processRawData" :disabled="!excelInput" :loading="processing">Process Data</v-btn>
            </v-layout>
            <div v-if="dataProcessed" class="mt-5">
              <span class="title">Output Data</span>
              <v-data-table hide-actions :items="processedData" :headers="columnMap">
                <template slot="items" slot-scope="props">
                  <tr>
                    <td :key="column" v-for="column in columnMap">{{props.item[column.value]}}</td>
                  </tr>
                </template>
              </v-data-table>
              <v-layout align-center>
                <v-spacer></v-spacer>
                <v-checkbox class="shrink" label="I confirm the above output is correct" v-model="dataLooksGood"></v-checkbox>
                <v-btn color="primary" @click="sendSimDetails" :loading="sending" :disabled="!dataLooksGood">Update Sim Details</v-btn>
              </v-layout>
            </div>
          </v-container>
          </v-card>
      </v-tab-item>
    </v-tabs>
      <v-container v-if="messageSent">
        <v-btn @click="reset" color="primary">Return</v-btn>
        <v-btn @click="resendSelectedMessages" color="secondary" :disabled="selectedMessages.length < 1">Resend Selected Messages</v-btn>
      <v-data-table
        :headers="headers"
        :items="filteredMessageStates"
        class="elevation-1"
        :expand="expandResults"
        item-key="id"
        hide-actions
      >
        <template v-slot:items="props">
          <tr>
            <td><v-checkbox v-model="selectedMessages" :value="props.item.id"/></td>
            <td @click="props.expanded = !props.expanded">{{ props.item.ICCID }}</td>
            <td @click="props.expanded = !props.expanded">{{ props.item.message }}</td>
            <td @click="props.expanded = !props.expanded">
              <v-progress-circular
                v-if="props.item.state === 0"
                indeterminate
                color="primary"
              ></v-progress-circular>
              <v-icon
                :color="props.item.state === -1 ? 'error' : 'success'"
                v-else
              >
                {{ props.item.state === -1 ? 'mdi-alert-circle' : 'mdi-check-circle' }}
              </v-icon>
            </td>
          </tr>
        </template>
        <template v-slot:expand="props">
          <v-card flat>
            <v-card-text v-if="props.item.packet">Request<pre>{{ props.item.packet }}</pre></v-card-text>
            <v-card-text v-if="props.item.response">Response<pre>{{ props.item.response }}</pre></v-card-text>
          </v-card>
        </template>
      </v-data-table>
    </v-container> 
  </v-layout>
</template>

<script>
import { fireStore } from '../firebase'
import moment from 'moment'
export default {
  data () {
    return {
      selectedMessages: [],
      active: null,
      addSimsDialog: false,
      adding: false,
      api: 'NIBC-API',
      simsLoading: false,
      provider: 'Vodafone',
      excelInput: '',
      dataLooksGood: false,
      includeHeaders: false,
      simSearch: '',
      processedData: [],
      dataProcessed: false,
      processing: false,
      expandResults: false,
      simDetailsSent: false,
      showDevices: false,
      availableColumns: [
        {text: 'simId', value: 'simId'},
        {text: 'customAttribute1', value: 'customAttribute1'},
        {text: 'customAttribute2', value: 'customAttribute2'},
        {text: 'customAttribute3', value: 'customAttribute3'},
        {text: 'customAttribute4', value: 'customAttribute4'},
        {text: 'customAttribute5', value: 'customAttribute5'},
        {text: 'state', value: 'state'},
        {text: 'customerServiceProfile', value: 'customerServiceProfile'}
      ],
      columnMap: [
        {text: 'simId', value: 'simId'},
        {text: 'customAttribute1', value: 'customAttribute1'},
        {text: 'customAttribute2', value: 'customAttribute2'},
        {text: 'customAttribute3', value: 'customAttribute3'},
        {text: 'customAttribute4', value: 'customAttribute4'},
        {text: 'customAttribute5', value: 'customAttribute5'},
        {text: 'state', value: 'state'},
        {text: 'customerServiceProfile', value: 'customerServiceProfile'}
      ],
      messageTemplates: [],
      messageType: 0,
      inputICCID: '',
      ICCIDarray: [],
      bulk: true,
      message: '',
      sending: false,
      messageSent: false,
      snap: null,
      headers: [
        { text: 'ICCID', value: 'ICCID' },
        { text: 'Message', value: 'message' },
        { text: 'State', value: 'state' }
      ],
      messageStates: [],
      types: [
        { type: 0, name: 'Payload SMS' },
        { type: 1, name: 'Transactional SMS' }
      ]
    }
  },
  beforeDestroy () {
    if (this.snap !== null) {
      this.snap()
    }
  },
  created () {
    this.$store.dispatch('fetchSIMS')
    this.$store.dispatch('fetchDevices')
    this.$store.dispatch('fetchDeviceTypes')
    this.getSMSTemplates()
  },
  computed: {
    simColumns () {
      let simColumns = [
        {text: 'ICCID', value: 'ICCID'},
        {text: 'Provider', value: 'provider'},
        {text: 'API-Key', value: 'api'}
      ]
      if (this.showDevices) {
        simColumns.push({text: 'Device', value: 'device'})
      }
      return simColumns
    },
    sims () {
      return this.$store.getters.SIMS
    },
    devices () {
      return this.$store.getters.devices
    },
    deviceTypes () {
      return this.$store.getters.deviceTypes
    },
    formattedSIMS () {
      let formattedSIMS = []
      if (!this.devices.length || !this.deviceTypes.length) {
        return formattedSIMS
      }
      for (let sim of this.sims) {
        if (this.showDevices) {
          let device = this.devices.find(device => { return sim.ICCID === device.SIM })
          sim.device = device ? this.deviceTypes.find(dtype => { return dtype.id === device.type }).name : ''
        }
        formattedSIMS.push(sim)
      }
      return formattedSIMS
    },
    filteredMessageStates () {
      let filteredMessageStates = []
      for (let i = 0; i < this.messageStates.length; i++) {
        let element = JSON.parse(JSON.stringify(this.messageStates[i]))
        element.message = atob(element.message)
        if (element.response === undefined) {
          element.state = 0
        } else {
          for (let value in element.response) {
            if (element.response.id) {
              element.state = -1
            } else if (element.response[value].return.returnCode.majorReturnCode === '000') {
              element.state = 1
            } else {
              element.state = -1
            }
          }
        }
        element.packet = element.packet === undefined ? '' : JSON.stringify(element.packet, null, ' ')
        element.response = element.response === undefined ? '' : JSON.stringify(element.response, null, ' ')
        filteredMessageStates.push(element)
      }
      return filteredMessageStates
    }
  },
  methods: {
    getSMSTemplates () {
      this.messageTemplates = []
      fireStore.collection('smsTemplates').orderBy('text').get().then((snap) => {
        snap.forEach((doc) => {
          this.messageTemplates.push(doc.data())
        })
      })
    },
    reset () {
      if (this.snap !== null) {
        this.snap()
      }
      this.adding = false
      this.addSimsDialog = false
      this.sending = false
      this.messageSent = false
    },
    fetchSIMS () {
      this.simsLoading = true
      this.sims = []
      fireStore.collection('SIMS').get().then(snap => {
        snap.forEach(doc => {
          let data = doc.data()
          this.sims.push(data)
        })
        this.simsLoading = false
      })
    },
    fetchDevices () {
      this.devices = []
      fireStore.collection('Devices').where('SIM', '>', '0').get().then(snap => {
        snap.forEach(doc => {
          let data = doc.data()
          this.devices.push(data)
        })
      })
    },
    addSIMS () {
      let batch = fireStore.batch()
      this.adding = true
      for (let ICCID of this.ICCIDarray) {
        batch.set(fireStore.collection('SIMS').doc(ICCID), { ICCID: ICCID, provider: this.provider, api: this.api }, { merge: true })
      }
      batch.commit().then(() => {
        this.reset()
      })
    },
    processRawData () {
      this.processing = true
      this.processedData = []
      const columnMap = this.columnMap
      let rows = []
      rows = this.excelInput.split('\n')
      if (this.includeHeaders) {
        rows.splice(0, 1)
      }
      rows.forEach(row => {
        if (row === '') {
          return
        }
        const cols = row.split('\t')
        const obj = {}
        for (let i = 0; i < cols.length; i++) {
          if (i === 0) {
            columnMap.splice(cols.length)
          }
          if (cols[i] && cols[i].length > 0 && columnMap[i]) {
            obj[columnMap[i].value] = cols[i]
          }
        }
        this.processedData.push(obj)
      })
      this.dataProcessed = true
      this.processing = false
    },
    updateICCID () {
      let concatICCIDs = this.inputICCID.replace(/\s/g, '').replace(/;/g, '').replace(/,/g, '')
      this.ICCIDarray = this.ICCIDarray.concat(concatICCIDs.match(/(.{1,20})/g)).filter((v, i, a) => a.indexOf(v) === i && !isNaN(v))
      this.inputICCID = ''
      this.bulk = false
    },
    startSnapshot (id) {
      this.snap = fireStore.collection('SIMmessages').doc(id).onSnapshot(snap => {
        let data = snap.data().messages
        for (let message of data) {
          message.id = message.ICCID + message.message
        }
        this.messageStates = data
        this.selectedMessages = []
      })
    },
    sendMessages () {
      this.sending = true
      let messageData = []
      for (let i = 0; i < this.ICCIDarray.length; i++) {
        if (this.ICCIDarray[i].length !== 20) {
          alert(`Cannot send messages! Invalid ID: ${this.ICCIDarray[i]}`)
          this.sending = false
          return
        }
        for (let m in this.message) {
          messageData.push({
            messageType: this.messageType,
            ICCID: this.ICCIDarray[i],
            message: btoa(this.message[m])
          })
        }
      }
      fireStore.collection('SIMmessages').add({
        messages: messageData,
        time: moment().format('YYYY-MM-DD HH:mm'),
        user: this.$store.getters.userData.Name
      }).then((val) => {
        this.startSnapshot(val.id)
        this.messageSent = true
      }).catch((error) => {
        alert('Unexpected Error Occured')
        console.log(error)
      })
    },
    resendSelectedMessages () {
      let dataToSend = []
      for (let message of this.selectedMessages) {
        let messageData = this.messageStates.find(m => m.id === message)
        delete messageData.response
        dataToSend.push(messageData)
      }
      this.snap()
      fireStore.collection('SIMmessages').add({
        messages: dataToSend,
        time: moment().format('YYYY-MM-DD HH:mm'),
        user: this.$store.getters.userData.Name
      }).then((val) => {
        this.startSnapshot(val.id)
        this.messageSent = true
      }).catch((error) => {
        alert('Unexpected Error Occured')
        console.log(error)
      })
    },
    sendSimDetails () {
      this.sending = true
      let messageData = []
      for (let i = 0; i < this.processedData.length; i++) {
        let msgObj = {}
        msgObj.packet = this.processedData[i]
        msgObj.packet.simIdType = 'ICCID'
        msgObj.messageType = 2
        msgObj.ICCID = msgObj.packet.simId
        msgObj.message = btoa('sim update')
        messageData.push(msgObj)
      }
      fireStore.collection('SIMmessages').add({
        messages: messageData,
        time: moment().format('YYYY-MM-DD HH:mm'),
        user: this.$store.getters.userData.Name
      }).then((val) => {
        this.startSnapshot(val.id)
        this.messageSent = true
      }).catch((error) => {
        alert('Unexpected Error Occured')
        console.log(error)
      })
    }
  }
}
</script>




// WEBPACK FOOTER //
// SIMS.vue?47483166